import React, { useEffect, useState, useRef } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";
import "./BybBanner.css";
import "../SelfResponsive.css";
import "../SelfTab.css";
import { Link } from "react-router-dom";

const HERO_VIDEO_SRC =
  "https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/header_video.webm";
const HERO_IMAGE_SRC =
  "https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/box.svg";
function BybBanner() {
  const [isDesktopHero, setIsDesktopHero] = useState(() =>
    typeof window === "undefined"
      ? true
      : window.matchMedia("(min-width: 992px)").matches
  );
  const [isHeroTextVisible, setIsHeroTextVisible] = useState(false);
  const [isHeroVideoVisible, setIsHeroVideoVisible] = useState(false);
  const videoEl = useRef(null);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 992px)");
    const handleChange = (event) => setIsDesktopHero(event.matches);

    setIsDesktopHero(mediaQuery.matches);

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener("change", handleChange);
    } else {
      mediaQuery.addListener(handleChange);
    }

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener("change", handleChange);
      } else {
        mediaQuery.removeListener(handleChange);
      }
    };
  }, []);

  useEffect(() => {
    if (isDesktopHero && videoEl.current) {
      setIsHeroTextVisible(false);
      setIsHeroVideoVisible(false);
      videoEl.current.currentTime = 0;
      videoEl.current.play().catch(() => {
        setIsHeroVideoVisible(true);
        setIsHeroTextVisible(true);
      });
    } else {
      setIsHeroVideoVisible(false);
      setIsHeroTextVisible(true);
    }
  }, [isDesktopHero]);

  // useEffect(() => {
  //   AOS.init({
  //     disable: "phone",
  //   });
  // }, []);

  useEffect(() => {
    document.body.style.backgroundColor = "rgb(7 26 40)";
    document.body
      .querySelectorAll(
        ".check_list, .byb-analysis, .byb-audit, .check_list.byb_believe, .legacy-content"
      )
      .forEach((element) => {
        element.style.background = "rgb(7 26 40)";
      });
  }, []);

  return (
    <>
      <section className="banner-byb" id="header_animation">
        <div className="container">
          <div className="banner-byb-content">
            <div className="animate__animated animate__fadeIn">
              {isDesktopHero && (
                <video
                  className="desktop_show"
                  width="1280"
                  height="720"
                  style={{
                    maxWidth: "100%",
                    width: "100%",
                    margin: "0 auto",
                    opacity: isHeroVideoVisible ? 1 : 0,
                    transition: "opacity 0.2s ease",
                  }}
                  playsInline
                  muted
                  autoPlay
                  aria-label="Brand Self-Audit Kit overview animation"
                  src={HERO_VIDEO_SRC}
                  preload="auto"
                  onPlaying={() => setIsHeroVideoVisible(true)}
                  onCanPlay={() => setIsHeroVideoVisible(true)}
                  onEnded={() => setIsHeroTextVisible(true)}
                  ref={videoEl}
                  loop={false}
                />
              )}

              <div className="show_mob">
                <div className="banner-byb-content header_content">
                  <p className="banner-first-p">BRAND SELF-AUDIT KIT</p>
                  <h1 className="evolve-text">
                    Great Brands Don't Happen, They <span className="highlight">Evolve.</span>
                  </h1>
                  <div className="mob_img header_kit">
                    <img
                      src={HERO_IMAGE_SRC}
                      alt="Brand self-audit kit hero box visual"
                      className="w-100"
                      width="720"
                      height="720"
                      decoding="async"
                      fetchPriority="high"
                    />
                  </div>

                  <div className="buy_btn">
                    <div className="banner-p-one">
                      <p>Pre-Book Printed Kit for</p>
                    </div>
                    <p>
                      <span className="banner-spanone">&#8377;14,999</span>
                      <span className="banner-spantwo">&#8377;7,999</span>
                    </p>
                    <div className="type_form_btn">
                      <Link to="https://rzp.io/rzp/brewyourbrand-checkout" className="blue_btn d-inline">
                        Buy
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={`${isHeroTextVisible ? "fade-in" : "fade-out"} banner-byb-content header_content desktop_show`}
              aria-hidden={!isHeroTextVisible}
              style={{ pointerEvents: isHeroTextVisible ? "auto" : "none" }}
            >
              <div className="sec_zoom">
                <p className="banner-first-p">BRAND SELF-AUDIT KIT</p>
                <h1 className="evolve-text">
                  Great Brands Don't Happen, They <span className="highlight">Evolve.</span>
                </h1>
                <div className="first_book">
                  <div className="banner-byb-content-para">
                    <div className="banner-p-one">
                      <p>Pre-Book Printed Kit for</p>
                    </div>
                    <div>
                      <p>
                        <span className="banner-spanone">&#8377;14,999</span>
                        <span className="banner-spantwo">&#8377;7,999</span>
                      </p>
                    </div>
                  </div>
                  <div className="type_form_btn">
                    <Link to="https://rzp.io/rzp/brewyourbrand-checkout" className="blue_btn d-inline">
                      Buy
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default BybBanner;
